import { SignalingRoomUser } from 'services/signaling';
import { checkPermissions } from 'features/permissions/utils/checkPermissions';
import { PermissionsState, PermissionTypes } from 'features/permissions/types';
import { select } from 'redux-saga/effects';
import { selectPermissionsState } from 'features/permissions/permissionsSlice';

export function* findRoomPublishersSaga(users: SignalingRoomUser[]) {
  const permissionsState: PermissionsState = yield select(selectPermissionsState);

  return users.filter(
    (user) =>
      checkPermissions({
        permissions: [PermissionTypes.broadcastVideo, PermissionTypes.broadcastAudio],
        permissionsState,
        role: user.role,
        mode: 'any',
        dynamicPermissions: user.dynamicPermissions,
      }) // || user.screensharing;;
  );
}
